import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Loader } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { useFtse4Good } from "../Sustainability.hook";
import { fields, fieldsReady } from "./constants";
export const FTSE4GoodPageContent: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");
  const [fieldData, setFieldData] = useState<any>();
  const [payloadData, setPayloadData] = useState<any>();

  const { data: profileData, isLoading: isLoadingProfile, refetch: refetchOurProfile } = useFtse4Good();
  const {
    data: profileDataById,
    isLoading: isLoadingprofileById,
    refetch: refetchOurProfileById,
  } = useDocumentDetails(query?.get("id") || "");

  console.log("profileDataById", profileDataById, profileData);

  useEffect(() => {
    if (query?.get("id")) {
      setPayloadData(profileDataById?.payload);
    } else {
      setPayloadData(profileData);
    }
  }, [profileData, profileDataById]);

  useEffect(() => {
    if (approveId) {
      refetchOurProfileById();
    } else {
      refetchOurProfile();
    }
  }, [query.get("subActiveTab"), approveId]);

  async function fetchData() {
    await fieldsReady;

    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const NextPageFormConfig: FormConfig = {
    initialValues: {
      [`field_content_english.data.nextPage.name`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_english)?.data?.nextPage?.name)
        : decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.name),

      [`field_content_english.data.nextPage.link`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_english)?.data?.nextPage?.link)
        : decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.link),
      [`field_content_malay.data.nextPage.name`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_malay)?.data?.nextPage?.name)
        : decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.name),
      [`field_content_malay.data.nextPage.link`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_malay)?.data?.nextPage?.link)
        : decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.link),
      [`field_content_mandarin.data.nextPage.name`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_mandarin)?.data?.nextPage?.name)
        : decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.name),
      [`field_content_mandarin.data.nextPage.link`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_mandarin)?.data?.nextPage?.link)
        : decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.link),
    },
    fields: fields?.nextPageOurPolicies,
  };

  console.log("NextPageFormConfig", NextPageFormConfig.fields, NextPageFormConfig.initialValues);

  const MainContentFormConfig: FormConfig = {
    initialValues: {
      [`field_content_english.data.image`]: profileDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: JSON.parse(profileDataById?.payload?.field_content_english)?.data?.image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: profileData?.[0]?.field_content_english?.data?.image,
            },
          ]),

      [`field_content_english.data.title`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_english)?.data?.title)
        : decodeHTML(profileData?.[0]?.field_content_english?.data?.title),
      [`field_content_english.data.description`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_english)?.data?.description)
        : decodeHTML(profileData?.[0]?.field_content_english?.data?.description),
      [`field_content_malay.data.image`]: profileDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: JSON.parse(profileDataById?.payload?.field_content_malay)?.data?.image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: profileData?.[0]?.field_content_malay?.data?.image,
            },
          ]),

      [`field_content_malay.data.title`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_malay)?.data?.title)
        : decodeHTML(profileData?.[0]?.field_content_malay?.data?.title),
      [`field_content_malay.data.description`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_malay)?.data?.description)
        : decodeHTML(profileData?.[0]?.field_content_malay?.data?.description),
      [`field_content_mandarin.data.image`]: profileDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: JSON.parse(profileDataById?.payload?.field_content_mandarin)?.data?.image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: profileData?.[0]?.field_content_mandarin?.data?.image,
            },
          ]),

      [`field_content_mandarin.data.title`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_mandarin)?.data?.title)
        : decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.title),
      [`field_content_mandarin.data.description`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_mandarin)?.data?.description)
        : decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.description),
    },
    fields: fields?.ftse4goodMainContent,
  };

  console.log(
    "MainContentFormConfig",
    MainContentFormConfig.fields,
    MainContentFormConfig.initialValues,
    fieldData,
    fields
  );

  const updatePayload = (data: any) => {
    const convertDotNotation = (obj: any): any => {
      const result: any = {};
      for (const key in obj) {
        if (key.includes(".")) {
          const topLevelKey = key.split(".")[0];
          if (obj[topLevelKey] && typeof obj[topLevelKey] === "object") {
            continue;
          }

          const parts = key.split(".");
          let current = result;

          for (let i = 0; i < parts.length - 1; i++) {
            current[parts[i]] = current[parts[i]] || {};
            current = current[parts[i]];
          }

          current[parts[parts.length - 1]] = obj[key];
        } else {
          result[key] = obj[key];
        }
      }

      return result;
    };

    const filterNestedObjects = (obj: any): any => {
      const result: any = {};

      for (const key in obj) {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          if (Array.isArray(obj[key])) {
            result[key] = obj[key];
          } else {
            result[key] = filterNestedObjects(obj[key]);
          }
        } else {
          result[key] = obj[key];
        }
      }

      return result;
    };

    const replacePayload = (target: any, source: any) => {
      console.log("replacePayload", target, source);

      for (const key in source) {
        console.log("sourceKey", key, target[key], source[key], Array.isArray(source[key]));

        if (key === "image") {
          const imageData = source[key];

          if (Array.isArray(imageData)) {
            if (imageData[0]?.originFileObj) {
              target[key] = imageData;
            } else {
              target[key] = imageData[0]?.url ?? undefined;
            }
          } else if (typeof imageData === "object" && imageData !== null) {
            // Ensure `undefined` values are explicitly handled
            target[key] = imageData.url !== undefined ? imageData.url : undefined;
          } else {
            target[key] = undefined;
          }
        } else if (typeof source[key] === "object" && source[key] !== null && !(source[key] instanceof Array)) {
          // If target[key] does not exist, initialize it as an object
          if (!target[key] || typeof target[key] !== "object") {
            target[key] = {};
          }
          replacePayload(target[key], source[key]);
        } else {
          // Assign values, making sure undefined values do not override existing values
          target[key] = source[key] !== undefined ? source[key] : target[key];
        }
      }
    };

    const convertedData = convertDotNotation(data);
    const filteredData = filterNestedObjects(convertedData);
    console.log("Data for...", data, filteredData);
    let payload = payloadData;
    if (profileDataById?.payload) {
      try {
        payload.field_content_english = JSON.parse(payload?.field_content_english);
        payload.field_content_malay = JSON.parse(payload?.field_content_malay);
        payload.field_content_mandarin = JSON.parse(payload?.field_content_mandarin);
      } catch (error) {
        console.error("Error parsing field_content_malay:", payload.field_content_malay);
        throw new Error("Invalid JSON string in field_content_malay");
      }
    } else {
      payload = payloadData[0];
    }
    payload = { ...payload };
    replacePayload(payload, filteredData);
    console.log("finaldata", data, payload);
    return payload;
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    const updateNestedProperty = (obj: any, path: string, value: any) => {
      const keys = path.split(".");
      let current = obj;

      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) current[keys[i]] = {};
        current = current[keys[i]];
      }

      current[keys[keys.length - 1]] = value;
    };

    const getNestedValue = (obj: any, path: string) => {
      return path.split(".").reduce((o: any, i: string) => {
        if (o == null) return undefined;
        return o[i];
      }, obj);
    };

    const payloadData = await updatePayload(data);

    let imageKeys = [
      "field_content_english.data.image",
      "field_content_malay.data.image",
      "field_content_mandarin.data.image",
    ];

    for (const key of imageKeys) {
      try {
        let field = key.split(".").reduce((o, i) => (o ? o[i] : undefined), payloadData);

        if (field && field[0]) {
          if (field[0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "CORPORATE");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              updateNestedProperty(payloadData, key, res.response.data);
            }
          } else if (field[0].url) {
            updateNestedProperty(payloadData, key, field[0].url);
          }
        }
      } catch (error) {
        console.error("Error updating image field:", key, error);
      }
    }
    const englishBannerKey = "field_content_english.data.image";
    const englishBanner = getNestedValue(payloadData, englishBannerKey);
    if (englishBanner) {
      updateNestedProperty(payloadData, "field_content_malay.data.image", englishBanner);
      updateNestedProperty(payloadData, "field_content_mandarin.data.image", englishBanner);
    }
    if (payloadData.field_content_english) {
      payloadData.field_content_english = JSON.stringify(payloadData.field_content_english);
    }
    if (payloadData.field_content_malay) {
      payloadData.field_content_malay = JSON.stringify(payloadData.field_content_malay);
    }
    if (payloadData.field_content_mandarin) {
      payloadData.field_content_mandarin = JSON.stringify(payloadData.field_content_mandarin);
    }
    let payload = {
      action: action,
      method: method,
      module: "Sustainability",
      subModule: `${query?.get("activeTab")}_${query?.get("subActiveTab")}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Sustainability_FTSE4 Good",
      payload: payloadData,
      status: status,
    };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  if (isLoadingprofileById || isLoadingProfile) {
    return <Loader />;
  }

  return (
    <>
      <DynamicForm
        isLoading={isLoadingProfile || isLoadingprofileById}
        config={MainContentFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "91"}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Sustainability"
      />
    </>
  );
};
